import { c as _c } from "react/compiler-runtime";
import { AffiliateDashboardTagButton } from 'modules/affiliate-dashboard/components/affiliate-dashboard-tag-button';
import { AffiliateDashboardVendorAvatarButton } from 'modules/affiliate-dashboard/components/affiliate-dashboard-vendor-avatar-button';
import { useAffiliateDashboardEmptyState } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-empty-state';
import { useAffiliateDashboardLeads } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-leads';
import { AffiliateDashboardFilterInterface, AffiliateDashboardFilterWithTagInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardLeadOptionInterface, AffiliateDashboardLeadsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-leads-interface';
import { AffiliateLeadCell, AffiliateOptinDate } from 'modules/affiliate/components/affiliate-lead-cell';
import { AffiliateLeadSource } from 'modules/affiliate/components/affiliate-lead-source';
import { AffiliateMobileCard } from 'modules/affiliate/components/affiliate-mobile-card';
import { AffiliateRowExpandToggle } from 'modules/affiliate/components/affiliate-row-expand-toggle';
import React, { useEffect, useState } from 'react';
import { FormSelect } from 'shared/components';
import ListingLayout from 'shared/components/listing-layout';
import { CompactTime, RelativeTime } from 'shared/components/relative-time';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useDidUpdateEffect } from 'shared/hooks/use-did-update-effect';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
interface AffiliateDashboardLeadsProps {
  mainFilter: AffiliateDashboardFilterInterface;
  tagsData: SelectorDataInterface<TagId>[] | undefined;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardLeads = t0 => {
  const $ = _c(123);
  const {
    mainFilter,
    tagsData,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    setFirstPage
  } = usePagination(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [opened, setOpened] = useState(t1);
  let t2;
  if ($[1] !== mainFilter) {
    t2 = {
      ...mainFilter,
      affiliateTag: undefined
    };
    $[1] = mainFilter;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [filterWithTag, setFilterWithTag] = useState(t2);
  let t3;
  if ($[3] !== setFirstPage) {
    t3 = tagId => {
      setFilterWithTag(prev => ({
        ...prev,
        affiliateTag: tagId
      }));
      setFirstPage();
    };
    $[3] = setFirstPage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const changeTag = t3;
  let t4;
  let t5;
  if ($[5] !== mainFilter) {
    t4 = () => {
      setFilterWithTag(prev_0 => ({
        ...prev_0,
        ...mainFilter
      }));
    };
    t5 = [mainFilter];
    $[5] = mainFilter;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== setFirstPage) {
    t6 = () => {
      setFirstPage();
    };
    $[8] = setFirstPage;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== mainFilter || $[11] !== setFirstPage) {
    t7 = [mainFilter, setFirstPage];
    $[10] = mainFilter;
    $[11] = setFirstPage;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  useDidUpdateEffect(t6, t7);
  let t8;
  if ($[13] !== filterWithTag || $[14] !== limit || $[15] !== pagination) {
    t8 = {
      filter: filterWithTag,
      pagination,
      limit
    };
    $[13] = filterWithTag;
    $[14] = limit;
    $[15] = pagination;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const {
    affiliateLeads,
    counter
  } = useAffiliateDashboardLeads(t8);
  const t9 = !!filterWithTag.vendorId || !!filterWithTag.affiliateTag;
  let t10;
  if ($[17] !== affiliateLeads || $[18] !== t9) {
    t10 = {
      data: affiliateLeads,
      isFiltered: t9
    };
    $[17] = affiliateLeads;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const {
    tableData,
    emptyStateProps
  } = useAffiliateDashboardEmptyState("leads", t10);
  let t11;
  let t12;
  if ($[20] !== affiliateLeads) {
    t11 = () => {
      if (affiliateLeads) {
        setOpened(affiliateLeads.items.reduce(_temp, {}));
      }
    };
    t12 = [affiliateLeads];
    $[20] = affiliateLeads;
    $[21] = t11;
    $[22] = t12;
  } else {
    t11 = $[21];
    t12 = $[22];
  }
  useEffect(t11, t12);
  let t13;
  if ($[23] !== setMainFilter) {
    t13 = lead => setMainFilter(prev_1 => ({
      ...prev_1,
      vendorId: lead.contact.user.id
    }));
    $[23] = setMainFilter;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const filterByVendor = t13;
  let t14;
  if ($[25] !== opened) {
    t14 = lead_0 => Boolean(opened[lead_0.contact.id]);
    $[25] = opened;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const isOpened = t14;
  let t15;
  if ($[27] !== isOpened) {
    t15 = lead_1 => <AffiliateRowExpandToggle expanded={isOpened(lead_1)} onClick={() => setOpened(prev_2 => ({
      ...prev_2,
      [lead_1.contact.id]: !prev_2[lead_1.contact.id]
    }))} />;
    $[27] = isOpened;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const renderExpandToggle = t15;
  let t16;
  if ($[29] !== isOpened) {
    t16 = lead_2 => isOpened(lead_2) ? lead_2.affiliateOptins.slice(1) : [];
    $[29] = isOpened;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const getAdditionalOptins = t16;
  let t17;
  if ($[31] !== filterByVendor) {
    t17 = lead_3 => <AffiliateDashboardVendorAvatarButton vendor={lead_3.contact.user} onClick={() => filterByVendor(lead_3)} />;
    $[31] = filterByVendor;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  const renderAvatar = t17;
  let t18;
  if ($[33] !== renderAvatar) {
    t18 = (lead_4, footer) => <div className="flex min-w-0 items-center gap-3">{renderAvatar(lead_4)}<div className="flex min-w-0 flex-col"><span className="text-text-primary truncate">{lead_4.contact.user.affiliateProgramBrandName}</span><span className="text-text-tertiary truncate text-sm">{lead_4.contactEmail}</span>{footer}</div></div>;
    $[33] = renderAvatar;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  const renderVendor = t18;
  const renderSource = _temp2;
  let t19;
  if ($[35] !== changeTag) {
    t19 = optin_0 => <AffiliateDashboardTagButton tag={optin_0?.affiliateTag} onClick={changeTag} />;
    $[35] = changeTag;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  const renderTag = t19;
  let t20;
  if ($[37] !== t) {
    t20 = t("dashboard.affiliate_dashboard.additional_sources");
    $[37] = t;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t20) {
    t21 = <span className="text-table-header-text truncate text-sm font-medium">{t20}</span>;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const additionalSourcesLabel = t21;
  let t22;
  if ($[41] !== t) {
    t22 = t("dashboard.affiliate_dashboard.vendor");
    $[41] = t;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== getAdditionalOptins || $[44] !== renderVendor) {
    t23 = lead_5 => <AffiliateLeadCell main={renderVendor(lead_5)} lines={getAdditionalOptins(lead_5).map(_temp3)} />;
    $[43] = getAdditionalOptins;
    $[44] = renderVendor;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== t22 || $[47] !== t23) {
    t24 = {
      key: "vendor",
      header: t22,
      widthPercent: 30,
      onRender: t23
    };
    $[46] = t22;
    $[47] = t23;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t) {
    t25 = t("dashboard.affiliate_dashboard.source_url");
    $[49] = t;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== additionalSourcesLabel || $[52] !== getAdditionalOptins) {
    t26 = lead_6 => <AffiliateLeadCell main={renderSource(lead_6.affiliateOptins[0])} label={additionalSourcesLabel} lines={getAdditionalOptins(lead_6).map(renderSource)} />;
    $[51] = additionalSourcesLabel;
    $[52] = getAdditionalOptins;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t25 || $[55] !== t26) {
    t27 = {
      key: "sourceUrl",
      header: t25,
      widthPercent: 30,
      onRender: t26
    };
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t) {
    t28 = t("dashboard.affiliate_dashboard.tags");
    $[57] = t;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== getAdditionalOptins || $[60] !== renderTag) {
    t29 = lead_7 => <AffiliateLeadCell main={renderTag(lead_7.affiliateOptins[0])} lines={getAdditionalOptins(lead_7).map(renderTag)} />;
    $[59] = getAdditionalOptins;
    $[60] = renderTag;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t28 || $[63] !== t29) {
    t30 = {
      key: "tags",
      header: t28,
      widthPercent: 20,
      onRender: t29
    };
    $[62] = t28;
    $[63] = t29;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] !== t) {
    t31 = t("global.date");
    $[65] = t;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== getAdditionalOptins || $[68] !== renderExpandToggle) {
    t32 = lead_8 => <AffiliateLeadCell main={<div className="flex min-w-0 flex-1 items-center justify-between gap-3">{lead_8.affiliateOptins[0] && <RelativeTime time={lead_8.affiliateOptins[0].date} />}{lead_8.affiliateOptins.length > 1 && renderExpandToggle(lead_8)}</div>} lines={getAdditionalOptins(lead_8).map(_temp4)} />;
    $[67] = getAdditionalOptins;
    $[68] = renderExpandToggle;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== t31 || $[71] !== t32) {
    t33 = {
      key: "date",
      header: t31,
      widthPercent: 20,
      onRender: t32
    };
    $[70] = t31;
    $[71] = t32;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== t24 || $[74] !== t27 || $[75] !== t30 || $[76] !== t33) {
    t34 = [t24, t27, t30, t33];
    $[73] = t24;
    $[74] = t27;
    $[75] = t30;
    $[76] = t33;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  const columns = t34;
  let t35;
  if ($[78] !== t) {
    t35 = t("dashboard.affiliate.leads.title");
    $[78] = t;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  let t36;
  if ($[80] !== mainFilter) {
    t36 = {
      ...mainFilter,
      affiliateTag: undefined
    };
    $[80] = mainFilter;
    $[81] = t36;
  } else {
    t36 = $[81];
  }
  let t37;
  if ($[82] !== filterWithTag || $[83] !== t36) {
    t37 = {
      filter: filterWithTag,
      setFilter: setFilterWithTag,
      defaultFilters: t36
    };
    $[82] = filterWithTag;
    $[83] = t36;
    $[84] = t37;
  } else {
    t37 = $[84];
  }
  let t38;
  if ($[85] !== t || $[86] !== tagsData) {
    t38 = [{
      field: "affiliateTag",
      onRender: (value, onChange) => <FormSelect placeholder={t("dashboard.affiliate_dashboard.any_tag")} value={value} data={tagsData} onChange={onChange} />
    }];
    $[85] = t;
    $[86] = tagsData;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== setPagination || $[89] !== t37 || $[90] !== t38) {
    t39 = {
      filterer: t37,
      setPagination,
      filterable: t38
    };
    $[88] = setPagination;
    $[89] = t37;
    $[90] = t38;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== limit || $[93] !== setLimit) {
    t40 = {
      limit,
      setLimit
    };
    $[92] = limit;
    $[93] = setLimit;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  let t41;
  if ($[95] !== pagination || $[96] !== setPagination) {
    t41 = {
      pagination,
      setPagination
    };
    $[95] = pagination;
    $[96] = setPagination;
    $[97] = t41;
  } else {
    t41 = $[97];
  }
  let t42;
  if ($[98] !== additionalSourcesLabel || $[99] !== getAdditionalOptins || $[100] !== renderExpandToggle || $[101] !== renderTag || $[102] !== renderVendor) {
    t42 = lead_9 => <div className="flex flex-col gap-3"><div className="flex items-center gap-5"><div className="min-w-0 flex-3">{renderVendor(lead_9, lead_9.affiliateOptins[0] && <CompactTime time={lead_9.affiliateOptins[0].date} />)}</div><div className="min-w-0 flex-3">{renderSource(lead_9.affiliateOptins[0])}</div><div className="min-w-0 flex-2">{renderTag(lead_9.affiliateOptins[0])}</div><div className="size-6 shrink-0">{lead_9.affiliateOptins.length > 1 && renderExpandToggle(lead_9)}</div></div>{getAdditionalOptins(lead_9).length > 0 && <div className="flex gap-5"><div className="flex-3" /><div className="flex min-w-0 flex-5 flex-col gap-3">{additionalSourcesLabel}{getAdditionalOptins(lead_9).map((optin_2, index_0) => <div key={index_0} className="flex items-start gap-5"><div className="flex min-w-0 flex-3 flex-col">{renderSource(optin_2)}<AffiliateOptinDate time={optin_2.date} /></div><div className="min-w-0 flex-2">{renderTag(optin_2)}</div></div>)}</div><div className="size-6 shrink-0" /></div>}</div>;
    $[98] = additionalSourcesLabel;
    $[99] = getAdditionalOptins;
    $[100] = renderExpandToggle;
    $[101] = renderTag;
    $[102] = renderVendor;
    $[103] = t42;
  } else {
    t42 = $[103];
  }
  let t43;
  if ($[104] !== additionalSourcesLabel || $[105] !== getAdditionalOptins || $[106] !== renderAvatar || $[107] !== renderExpandToggle || $[108] !== renderTag) {
    t43 = lead_10 => <AffiliateMobileCard avatar={renderAvatar(lead_10)} aside={lead_10.affiliateOptins.length > 1 && renderExpandToggle(lead_10)} footer={(lead_10.affiliateOptins[0]?.affiliateTag || getAdditionalOptins(lead_10).length > 0) && <div className="flex min-w-0 flex-col gap-3">{renderTag(lead_10.affiliateOptins[0])}{getAdditionalOptins(lead_10).length > 0 && <div className="flex min-w-0 flex-col gap-3">{additionalSourcesLabel}{getAdditionalOptins(lead_10).map((optin_3, index_1) => <div key={index_1} className="flex min-w-0 flex-col"><div className="flex min-w-0 items-center gap-3"><div className="min-w-0 flex-1">{renderSource(optin_3)}</div>{optin_3.affiliateTag && <div className="flex max-w-1/2 min-w-0 shrink-0">{renderTag(optin_3)}</div>}</div><AffiliateOptinDate time={optin_3.date} /></div>)}</div>}</div>}><span className="text-text-primary truncate">{lead_10.contact.user.affiliateProgramBrandName}</span>{renderSource(lead_10.affiliateOptins[0])}<span className="text-text-tertiary truncate text-sm">{lead_10.contactEmail}</span>{lead_10.affiliateOptins[0] && <RelativeTime time={lead_10.affiliateOptins[0].date} />}</AffiliateMobileCard>;
    $[104] = additionalSourcesLabel;
    $[105] = getAdditionalOptins;
    $[106] = renderAvatar;
    $[107] = renderExpandToggle;
    $[108] = renderTag;
    $[109] = t43;
  } else {
    t43 = $[109];
  }
  let t44;
  if ($[110] !== columns || $[111] !== emptyStateProps || $[112] !== t40 || $[113] !== t41 || $[114] !== t42 || $[115] !== t43 || $[116] !== tableData) {
    t44 = <Table getRowId={_temp5} data={tableData} columns={columns} limiter={t40} paginator={t41} emptyStateProps={emptyStateProps} renderTabletRow={t42} renderMobileRow={t43} />;
    $[110] = columns;
    $[111] = emptyStateProps;
    $[112] = t40;
    $[113] = t41;
    $[114] = t42;
    $[115] = t43;
    $[116] = tableData;
    $[117] = t44;
  } else {
    t44 = $[117];
  }
  let t45;
  if ($[118] !== counter || $[119] !== t35 || $[120] !== t39 || $[121] !== t44) {
    t45 = <ListingLayout counter={counter} title={t35} filterData={t39}>{t44}</ListingLayout>;
    $[118] = counter;
    $[119] = t35;
    $[120] = t39;
    $[121] = t44;
    $[122] = t45;
  } else {
    t45 = $[122];
  }
  return t45;
};
export default AffiliateDashboardLeads;
function _temp(acc, cur) {
  return {
    ...acc,
    [cur.contact.id]: false
  };
}
function _temp2(optin) {
  return optin?.sourceUrl || optin?.sourceText ? <AffiliateLeadSource sourceUrl={optin.sourceUrl} sourceText={optin.sourceText} /> : null;
}
function _temp3() {
  return null;
}
function _temp4(optin_1, index) {
  return <AffiliateOptinDate key={index} time={optin_1.date} />;
}
function _temp5(row) {
  return row.contact.id;
}